import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { FAQ_IDS } from "../data/structure";
import { websiteLd, webpageLd, personLd, faqLd, breadcrumbLd } from "../lib/jsonld";

import Hero from "../components/Hero";
import TrustSection from "../components/TrustSection";
import ErasJourney from "../components/ErasJourney";
import { Section } from "../components/Section";
import CareerPillars from "../components/CareerPillars";
import WorksHighlights from "../components/WorksHighlights";
import EditorialEssay from "../components/EditorialEssay";
import GlobalImpact from "../components/GlobalImpact";
import FaqSection from "../components/FaqSection";
import OfficialLinks from "../components/OfficialLinks";

export default function Home({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.home;
  const faqArr = FAQ_IDS.map((id) => d.faq[id]);

  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      websiteLd(),
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      personLd(),
      faqLd(faqArr),
      breadcrumbLd([{ name: d.ui.nav.home, path: pathFor(lang, "home") }]),
    ],
  });

  return (
    <>
      <Hero />
      <TrustSection />

      <ErasJourney />

      <Section testid="timeline-preview" className="!pt-0">
        <div className="text-center">
          <Link
            to={pathFor(lang, "timeline")}
            data-testid="view-full-timeline"
            className="focus-gold group inline-flex items-center gap-2 rounded-full bg-jlo-gold px-7 py-3.5 text-sm font-semibold text-jlo-bg hover:bg-jlo-warm transition-colors"
          >
            {d.ui.exploreTimeline}
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </Section>

      <CareerPillars />
      <WorksHighlights />
      <EditorialEssay />
      <GlobalImpact />
      <FaqSection />
      <OfficialLinks />
    </>
  );
}
